import { risapi, getAxiosConfig } from './risapi';

/**
 * Fetches the list of available subscription plans from the server.
 * @param {function} callback The callback function to handle the response.
 */
export const getSubscriptionPlans = async (callback) => {
    try {
        const response = await risapi.get('/api/subscription-plans', getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
};

/**
 * Submits the user's chosen plan to the server to create a subscription.
 * @param {number} planId The ID of the selected subscription plan.
 * @param {function} callback The callback function to handle the response.
 */
export const selectSubscriptionPlan = async (planId, callback) => {
    try {
        const response = await risapi.post('/api/subscribe', { plan_id: planId }, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
};


/**
 * Creates a Razorpay order for the selected plan.
 */
export const createSubscriptionOrder = async (planId, callback) => {
    try {
        const response = await risapi.post('/api/subscribe/create-order', { plan_id: planId }, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error.response.data);
    }
};

/**
 * Verifies the Razorpay payment on the backend.
 */
export const verifySubscriptionPayment = async (data, callback) => {
    try {
        const response = await risapi.post('/api/subscribe/verify-payment', data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error.response.data);
    }
};
